import { render, staticRenderFns } from "./forgetPw_km.vue?vue&type=template&id=28e98054&"
import script from "./forgetPw_km.vue?vue&type=script&lang=js&"
export * from "./forgetPw_km.vue?vue&type=script&lang=js&"
import style0 from "./forgetPw_km.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports